import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import HTMLRenderer from '../HTMLRender/HTMLRenderer';
import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';
import MarkdownComponent from '../MarkdownComponent/MarkdownComponent';
import { markdownPageEnglish, markdownPageSpanish } from './PrivacyPolicyContent';
import styles from './PrivacyPolicy.module.scss';
import BackwardArrow from '@jwp/ott-theme/assets/icons/arrow_backward.svg';
import IconButton from '../IconButton/IconButton';
import { useLocation, useNavigate } from 'react-router';

import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
type Props = {
  panelClassName?: string;
  panelHeaderClassName?: string;
};

const PrivacyPolicy = ({ panelClassName }: Props): JSX.Element => {
  const { canShowPrivacyPolicy } = useAppConfig();
  const privacyPolicy = useConfigStore((state) => state.privacyPolicy);
  const { i18n, t } = useTranslation('common');
  const location = useLocation();

  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  };

  const showBack = location.pathname.startsWith('/privacy-policy');
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const markdownContent = () => {
    if (i18n.language === 'en') { return markdownPageEnglish; }
    if (i18n.language === 'es') { return markdownPageSpanish; }
    return 'Language not supported';
  };

  // Optional fallback if HTML isn't ready
  if (!privacyPolicy?.en && !privacyPolicy?.es && canShowPrivacyPolicy) {
    return (
      <>
        {showBack && (
          <div className={styles.headerTitlePart}>
            <IconButton className={styles.iconButton} aria-controls="sidebar" aria-haspopup="true" onClick={handleBackClick}>
              <img src={BackwardArrow} />
            </IconButton>
          </div>
        )}
        <section className={panelClassName}>
          <MarkdownComponent className={styles.about} markdownStyle={styles.markdown} markdownString={markdownContent()} />
        </section>
      </>
    );
  }

  return (
    <>
      {showBack && (
        <div className={styles.headerTitlePart}>
          <IconButton className={styles.iconButton} aria-controls="sidebar" aria-haspopup="true" onClick={handleBackClick}>
            <img src={BackwardArrow} />
          </IconButton>
        </div>
      )}
      <section className={panelClassName}>
        <HTMLRenderer
          className={styles.legalDocsContainer}
          html={i18n.language === 'es' ? (privacyPolicy?.es ? privacyPolicy?.es : privacyPolicy?.en) : privacyPolicy?.en}
        />
      </section>
    </>
  );
};

export default PrivacyPolicy;
